module.exports = __webpack_public_path__ + "static/media/calendar-check.db6e2802.svg";